module.exports = __webpack_public_path__ + "static/img/Sina_Weibo.e7f97bf6.png";